
// import React, { useState } from 'react';
// import Button from '../../components/common/Button';
// import { useAuth } from '../../contexts/AuthContext';
// import { subscribeToNewsletter } from '../../services/newsletterService';

// const Footer = () => {
//   const [email, setEmail] = useState('');
//   const [isSubscribing, setIsSubscribing] = useState(false);
//   const { user } = useAuth();

//   const handleSubscribe = async (e) => {
//     e.preventDefault();
    
//     setIsSubscribing(true);

//     const result = await subscribeToNewsletter(email, user?.id);

//     if (result.success) {
//       setEmail(''); // Clear the input on success
//     }

//     setIsSubscribing(false);
//   };

//   return (
//     <footer className="bg-black text-white py-12">
//       <div className="container mx-auto px-4">
//         <div className="grid md:grid-cols-4 gap-8">
//           <div>
//             <img 
//               src="/img/Logo_Directory/yellow_ordinary.svg" 
//               alt="JmoLux Logo" 
//               className="h-10 mb-4" 
//             />
//             <p className="text-gray-400">
//               Curating the world's finest luxury experiences since 2020
//             </p>
//           </div>
//           <div>
//             <h4 className="font-semibold mb-4">Quick Links</h4>
//             <ul className="space-y-2 text-gray-400">
//               <li><a href="#" className="hover:text-white">About Us</a></li>
//               <li><a href="#" className="hover:text-white">Collections</a></li>
//               <li><a href="#" className="hover:text-white">Contact</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="font-semibold mb-4">Customer Care</h4>
//             <ul className="space-y-2 text-gray-400">
//               <li><a href="#" className="hover:text-white">Shipping Info</a></li>
//               <li><a href="#" className="hover:text-white">Returns</a></li>
//               <li><a href="#" className="hover:text-white">Size Guide</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="font-semibold mb-4">Newsletter</h4>
//             <p className="text-gray-400 mb-4">Subscribe for exclusive offers</p>
//             {!user && (
//               <p className="text-amber-400 text-sm mb-2">Please log in to subscribe</p>
//             )}
//             <form onSubmit={handleSubscribe} className="flex">
//               <input 
//                 type="email" 
//                 placeholder="Your email" 
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 disabled={isSubscribing || !user}
//                 className="flex-1 px-4 py-2 rounded-l bg-gray-800 text-white placeholder-gray-500 disabled:opacity-50"
//               />
//               <Button 
//                 type="submit"
//                 variant="gold" 
//                 className="rounded-l-none"
//                 disabled={isSubscribing || !user}
//               >
//                 {isSubscribing ? 'Subscribing...' : 'Subscribe'}
//               </Button>
//             </form>
//           </div>
//         </div>
//         <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
//           <p>&copy; 2024 JmoLux. All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;



import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/common/Button';
import { useAuth } from '../../contexts/AuthContext';
import { subscribeToNewsletter, checkSubscriptionStatus } from '../../services/newsletterService';
import { trackGenerateLead } from '../../lib/analytics';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const { user } = useAuth();

  const checkStatus = useCallback(async () => {
    if (!user?.id) return;
    const result = await checkSubscriptionStatus(user.id);
    setIsSubscribed(result.isSubscribed);
  }, [user?.id]);

  // Check subscription status when user logs in
  useEffect(() => {
    if (user?.id) {
      checkStatus();
    } else {
      setIsSubscribed(false);
    }
  }, [checkStatus, user?.id]);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (isSubscribed) return; // Don't allow resubscribing if already subscribed
    
    setIsSubscribing(true);

    const result = await subscribeToNewsletter(email, user?.id, user?.email);

    // Clear the input on success OR if already subscribed
    if (result.success) {
      setEmail('');
      setIsSubscribed(true);
      trackGenerateLead({ formName: 'newsletter' });
    } else if (result.alreadySubscribed) {
      setEmail('');
      setIsSubscribed(true);
    }

    setIsSubscribing(false);
  };

  return (
    <footer className="bg-black py-10 font-sans text-white md:py-12">
      <div className="container mx-auto px-5 sm:px-6">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-4 md:gap-8">
          <div className="col-span-2 flex flex-col items-center text-center md:col-span-1 md:items-start md:text-left">
            <img
              src="/img/Logo_Directory/crest_gold_real_transparent.png"
              alt="JmoLux Crest"
              className="mb-4 h-14 w-auto object-contain"
            />
            <p className="max-w-xs text-xs font-light leading-relaxed text-gray-400">
              Curating the world's finest luxury experiences since 2020
            </p>
          </div>
          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-amber-100">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/about" className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-amber-200 hover:text-amber-400 transition-colors">About Us</Link></li>
              <li><Link to="/collections" className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-amber-200 hover:text-amber-400 transition-colors">Collections</Link></li>
              <li><Link to="/contact" className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-amber-200 hover:text-amber-400 transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-amber-100">Customer Care</h4>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/shipping-info" className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-amber-200 hover:text-amber-400 transition-colors">Shipping Info</Link></li>
              <li><Link to="/returns" className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-amber-200 hover:text-amber-400 transition-colors">Returns</Link></li>
              <li><Link to="/sizing-help" className="text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-amber-200 hover:text-amber-400 transition-colors">Sizing Help</Link></li>
            </ul>
          </div>
          <div className="col-span-2 border-t border-gray-800 pt-8 text-center md:col-span-1 md:border-0 md:pt-0 md:text-left">
            <h4 className="mb-3 text-xs font-semibold uppercase tracking-wider text-amber-100">Newsletter</h4>
            <p className="mb-4 text-xs font-light text-gray-400">Subscribe for exclusive offers</p>
            <form onSubmit={handleSubscribe} className="mx-auto flex max-w-md flex-col gap-3 md:mx-0 lg:flex-row lg:gap-0">
              <input
                type="email"
                placeholder={user?.email || "Your email"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubscribing || isSubscribed}
                aria-label="Email address"
                className="min-w-0 flex-1 rounded-md bg-gray-800 px-4 py-3 font-sans text-xs font-medium uppercase tracking-wider text-white placeholder-gray-500 outline-none transition focus:ring-2 focus:ring-amber-400 disabled:opacity-50 lg:rounded-r-none"
              />
              <Button
                type="submit"
                variant="gold"
                className="w-full whitespace-nowrap !rounded-md !font-sans !text-xs !font-semibold !uppercase !tracking-wider lg:w-auto lg:!rounded-l-none"
                disabled={isSubscribing || isSubscribed}
              >
                {isSubscribing ? 'Subscribing...' : isSubscribed ? 'Subscribed' : 'Subscribe'}
              </Button>
            </form>
          </div>
        </div>
        <div className="mt-10 border-t border-gray-800 pt-6 text-center md:mt-8 md:pt-8">
          <p className="text-xs font-light text-gray-400">&copy; 2024 JmoLux. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
